/* eslint-disable no-magic-numbers */
// Font Awesome 5 Vue component https://fontawesome.com
// @see https://github.com/FortAwesome/vue-fontawesome#usage
// @see https://fontawesome.com/icons?d=gallery - search for icons!
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Custom icons
// @see https://github.com/FortAwesome/Font-Awesome/wiki/Customize-Font-Awesome#svg-framework

// Custom FA5 icon for the teaming logo
const teamingLogoSolid = {
	prefix: "fac", // for font-awesome-custom....just the facs, ma'am.
	iconName: "teaming-logo-solid",
	icon: [ 64, 60, [], "e001", "M45.9636 18.365C55.8545 18.365 63.9354 26.4458 64 36.4013V59.9973H55.9838V36.4013C55.9838 30.8417 51.4586 26.3811 45.9636 26.3811C40.4687 26.3811 36.0081 30.9064 36.0081 36.4013V59.9973H27.9919V36.4013C27.9919 30.8417 23.4667 26.3811 17.9717 26.3811C12.4768 26.3811 8.01616 30.9064 8.01616 36.4013V59.9973H0V36.4013C0 26.4458 8.01616 18.365 17.9717 18.365C23.605 18.365 28.651 20.9861 31.9635 25.082C35.2526 20.9861 40.2936 18.365 45.9636 18.365ZM17.9071 0.0700073C22.1091 0.0700073 25.5354 3.49627 25.5354 7.69829C25.5354 11.9003 22.1091 15.3912 17.9071 15.3912C13.705 15.3912 10.3434 11.9003 10.3434 7.69829C10.3434 3.49627 13.705 0.0700073 17.9071 0.0700073ZM45.899 0.0700073C50.101 0.0700073 53.5273 3.49627 53.5273 7.69829C53.5273 11.9003 50.101 15.3266 45.899 15.3266C41.697 15.3912 38.3354 11.9003 38.3354 7.69829C38.3354 3.49627 41.697 0.0700073 45.899 0.0700073Z", ],
};

const oneOnOneIconSolid = {
	prefix: "fac",
	iconName: "one-on-one",
	icon: [ 20, 14, [], "e002", "M18 0H2C0.895313 0 0 0.895313 0 2V12C0 13.1047 0.895313 14 2 14H18C19.1047 14 20 13.1047 20 12V2C20 0.895313 19.1031 0 18 0ZM6 9.49999H7.25C7.66562 9.49999 8 9.83593 8 10.25C8 10.6641 7.66406 11 7.25 11H3.25C2.8375 11 2.5 10.6641 2.5 10.25C2.5 9.83593 2.83594 9.49999 3.25 9.49999H4.5V5.14999L4.04 5.42987C3.69469 5.65843 3.229 5.56562 3 5.22187C2.77187 4.90312 2.86563 4.43749 3.20906 4.20899L4.83406 3.12587C5.065 2.97156 5.36091 2.95787 5.60406 3.08874C5.84766 3.21968 6 3.47362 6 3.74999V9.49999ZM15.5 9.49999H16.75C17.1656 9.49999 17.5 9.83593 17.5 10.25C17.5 10.6641 17.1641 11 16.75 11H12.75C12.3375 11 12 10.6641 12 10.25C12 9.83593 12.3359 9.49999 12.75 9.49999H14V5.14999L13.54 5.42987C13.1947 5.65843 12.729 5.56562 12.5 5.22187C12.2719 4.90312 12.3656 4.43749 12.7091 4.20899L14.3341 3.12587C14.565 2.97156 14.8609 2.95787 15.1041 3.08874C15.3477 3.21968 15.5 3.47362 15.5 3.74999V9.49999ZM9.125 5.25C9.125 5.13389 9.125 5.07584 9.13142 5.02711C9.17572 4.69056 9.44056 4.42572 9.77711 4.38142C9.82584 4.375 9.88389 4.375 10 4.375C10.1161 4.375 10.1742 4.375 10.2229 4.38142C10.5594 4.42572 10.8243 4.69056 10.8686 5.02711C10.875 5.07584 10.875 5.13389 10.875 5.25C10.875 5.36611 10.875 5.42416 10.8686 5.47289C10.8243 5.80944 10.5594 6.07428 10.2229 6.11858C10.1742 6.125 10.1161 6.125 10 6.125C9.88389 6.125 9.82584 6.125 9.77711 6.11858C9.44056 6.07428 9.17572 5.80944 9.13142 5.47289C9.125 5.42416 9.125 5.36611 9.125 5.25ZM9.125 8.75C9.125 8.63389 9.125 8.57584 9.13142 8.52711C9.17572 8.19056 9.44056 7.92572 9.77711 7.88142C9.82584 7.875 9.88389 7.875 10 7.875C10.1161 7.875 10.1742 7.875 10.2229 7.88142C10.5594 7.92572 10.8243 8.19056 10.8686 8.52711C10.875 8.57584 10.875 8.63389 10.875 8.75C10.875 8.86611 10.875 8.92416 10.8686 8.97289C10.8243 9.30944 10.5594 9.57428 10.2229 9.61858C10.1742 9.625 10.1161 9.625 10 9.625C9.88389 9.625 9.82584 9.625 9.77711 9.61858C9.44056 9.57428 9.17572 9.30944 9.13142 8.97289C9.125 8.92416 9.125 8.86611 9.125 8.75Z", ],
};

// import the symbols...
import {
	faBullseyeArrow as proDuotoneBullseyeArrow,
	faCalendarAlt as proDuotoneCalendarAlt,
	faCalendarCheck as proDuotoneCalendarCheck,
	faCalendarStar as proDuotoneCalendarStar,
	faChartNetwork as proDuotoneChartNetwork,
	faCheckCircle as proDuotoneCheckCircle,
	faCheckDouble as proDuoToneCheckDouble,
	faClipboard as proDuotoneClipboard,
	faClipboardCheck as proDuotoneClipboardCheck,
	faClock as proDuotoneClock,
	faDna as proDuotoneDna,
	faDumbbell as proDuotoneDumbell,
	faEyeSlash as proDuotoneEyeSlash,
	faGavel as proDuotoneGavel,
	faHeadSideBrain as proDuotoneHeadSideBrain,
	faHeartbeat as proDuotoneHeartbeat,
	faLowVision as proDuotoneLowVision,
	faPeopleArrows as proDuotonePeopleArrows,
	faSortAlphaDown as proDuotoneSortAlphaDown,
	faSortAlphaDownAlt as proDuotoneSortAlphaDownAlt,
	faTasks as proDuotoneTasks,
	faUsers as proDuotoneUsers,
	faUsersCog as proDuotoneUsersCog
} from "@fortawesome/pro-duotone-svg-icons";

import {
	faAngleDoubleDown as freeSolidAngleDoubleDown,
	faAngleDoubleUp as freeSolidAngleDoubleUp,
	faAngleRight as freeSolidAngleRight,
	faArrowLeft as freeSolidArrowLeft,
	faArrowUp as freeSolidArrowUp,
	faBold as freeSolidBold,
	faBook as freeSolidBook,
	faCalendarAlt as freeSolidCalendarAlt,
	faCalendarCheck as freeSolidCalendarCheck,
	faCalendarPlus as freeSolidCalendarPlus,
	faCalendarWeek as freeSolidCalendarWeek,
	faCaretDown as freeSolidCaretDown,
	faCaretLeft as freeSolidCaretLeft,
	faCaretUp as freeSolidCaretUp,
	faChalkboardTeacher as freeSolidChalkboardTeacher,
	faCheck as freeSolidCheck,
	faCheckCircle as freeSolidCheckCircle,
	faCheckDouble as freeSolidCheckDouble,
	faCheckSquare as freeSolidCheckSquare,
	faChevronDown as freeSolidChevronDown,
	faChevronLeft as freeSolidChevronLeft,
	faChevronRight as freeSolidChevronRight,
	faCircle as freeSolidCircle,
	faClipboardCheck as freeSolidClipboardCheck,
	faClock as freeSolidClock,
	faCog as freeSolidCog,
	faDollarSign as freeSolidDollarSign,
	faEnvelope as freeSolidEnvelope,
	faExclamationCircle as freeSolidExclamationCircle,
	faExclamationTriangle as freeSolidExclamationTriangle,
	faEye as freeSolidEye,
	faEyeSlash as freeSolidEyeSlash,
	faGavel as freeSolidGavel,
	faGripVertical as freeSolidGripVertical,
	faInfoCircle as freeSolidInfoCircle,
	faItalic as freeSolidItalic,
	faList as freeSolidList,
	faListOl as freeSolidListOl,
	faMinus as freeSolidMinus,
	faPaperPlane as freeSolidPaperPlane,
	faPeopleArrows as freeSolidPeopleArrows,
	faPlay as freeSolidPlay,
	faPlayCircle as freeSolidPlayCircle,
	faPlus as freeSolidPlus,
	faPowerOff as freeSolidPowerOff,
	faQuestionCircle as freeSolidQuestionCircle,
	faSignInAlt as freeSolidSignInAlt,
	faSlidersH as freeSolidSlidersH,
	faSortDown as freeSolidSortDown,
	faSortUp as freeSolidSortUp,
	faStar as freeSolidStar,
	faStepForward as freeSolidStepForward,
	faStickyNote as freeSolidStickyNote,
	faStopwatch as freeSolidStopwatch,
	faSyncAlt as freeSyncAlt,
	faTimes as freeSolidTimes,
	faTimesCircle as freeSolidTimesCircle,
	faTrash as freeSolidTrash,
	faTrashAlt as freeSolidTrashAlt,
	faUser as freeSolidUser,
	faUserCircle as freeSolidUserCircle,
	faUsers as freeSolidUsers
} from "@fortawesome/free-solid-svg-icons";

import {
	faBullseyeArrow as proRegularBullseyeArrow,
	faCalendar as proRegularCalendar,
	faCalendarCheck as proRegularCalendarCheck,
	faCalendarPlus as proRegularCalendarPlus,
	faCalendarWeek as proRegularCalendarWeek,
	faClipboardCheck as proRegularClipboardCheck,
	faCog as proRegularCog,
	faEllipsisH as proRegularEllipsisH,
	faEllipsisV as proRegularEllipsisV,
	faInfoCircle as proRegularInfoCircle,
	faSortAlphaDown as proRegularSortAlphaDown,
	faSortAlphaDownAlt as proRegularSortAlphaDownAlt,
	faSquare as proRegularSquare,
	faStar as proRegularStar,
	faStopwatch as proRegularStopwatch,
	faThumbtack as proRegularThumbtack,
	faTimesCircle as proRegularTimesCircle
} from "@fortawesome/pro-regular-svg-icons";

import {
	faAlarmSnooze as proSolidAlarmSnooze,
	faBars as proSolidBars,
	faBellExclamation as proSolidBellExclamation,
	faBullseyeArrow as proSolidBullseyeArrow,
	faCalendarStar as proSolidCalendarStar,
	faCheckSquare as proSolidCheckSquare,
	faCommentsQuestionCheck as proSolidCommentsQuestionCheck,
	faExclamationSquare as proSolidExclamationSquare,
	faInboxIn as proSolidInboxIn,
	faMugTea as proSolidMugTea,
	faPencil as proSolidPencil,
	faRepeatAlt as proSolidRepeatAlt,
	faSignOut as proSolidSignOut,
	faSync as proSolidSync,
	faThumbtack as proSolidThumbtack,
	faUserSlash as proSolidUserSlash,
	faUsersSlash as proSolidUsersSlash
} from "@fortawesome/pro-solid-svg-icons";

import {
	faMarkdown as freeBrandMarkdown
} from "@fortawesome/free-brands-svg-icons";

// additional available libraries
// import { faIconName } from '@fortawesome/pro-light-svg-icons'

// ...add them to the library
library.add(
	teamingLogoSolid,
	oneOnOneIconSolid,
	freeBrandMarkdown,
	freeSolidAngleDoubleDown,
	freeSolidAngleDoubleUp,
	freeSolidAngleRight,
	freeSolidArrowLeft,
	freeSolidArrowUp,
	freeSolidBold,
	freeSolidBook,
	freeSolidCalendarAlt,
	freeSolidCalendarCheck,
	freeSolidCalendarPlus,
	freeSolidCalendarWeek,
	freeSolidCaretDown,
	freeSolidCaretLeft,
	freeSolidCaretUp,
	freeSolidChalkboardTeacher,
	freeSolidCheck,
	freeSolidCheckCircle,
	freeSolidCheckDouble,
	freeSolidCheckSquare,
	freeSolidChevronDown,
	freeSolidChevronLeft,
	freeSolidChevronRight,
	freeSolidCircle,
	freeSolidClipboardCheck,
	freeSolidClock,
	freeSolidCog,
	freeSolidDollarSign,
	freeSolidEnvelope,
	freeSolidExclamationCircle,
	freeSolidExclamationTriangle,
	freeSolidEye,
	freeSolidEyeSlash,
	freeSolidGavel,
	freeSolidGripVertical,
	freeSolidInfoCircle,
	freeSolidItalic,
	freeSolidList,
	freeSolidListOl,
	freeSolidMinus,
	freeSolidPaperPlane,
	freeSolidPeopleArrows,
	freeSolidPlay,
	freeSolidPlayCircle,
	freeSolidPlus,
	freeSolidPowerOff,
	freeSolidQuestionCircle,
	freeSolidSignInAlt,
	freeSolidSlidersH,
	freeSolidSortDown,
	freeSolidSortUp,
	freeSolidStar,
	freeSolidStepForward,
	freeSolidStickyNote,
	freeSolidStopwatch,
	freeSolidTimes,
	freeSolidTimesCircle,
	freeSolidTrash,
	freeSolidTrashAlt,
	freeSolidUser,
	freeSolidUserCircle,
	freeSolidUsers,
	freeSyncAlt,
	proDuoToneCheckDouble,
	proDuotoneBullseyeArrow,
	proDuotoneCalendarAlt,
	proDuotoneCalendarCheck,
	proDuotoneCalendarStar,
	proDuotoneChartNetwork,
	proDuotoneCheckCircle,
	proDuotoneClipboard,
	proDuotoneClipboardCheck,
	proDuotoneClock,
	proDuotoneDna,
	proDuotoneDumbell,
	proDuotoneEyeSlash,
	proDuotoneGavel,
	proDuotoneHeadSideBrain,
	proDuotoneHeartbeat,
	proDuotoneLowVision,
	proDuotonePeopleArrows,
	proDuotoneSortAlphaDown,
	proDuotoneSortAlphaDown,
	proDuotoneSortAlphaDownAlt,
	proDuotoneSortAlphaDownAlt,
	proDuotoneTasks,
	proDuotoneUsers,
	proDuotoneUsersCog,
	proRegularBullseyeArrow,
	proRegularCalendar,
	proRegularCalendarCheck,
	proRegularCalendarPlus,
	proRegularCalendarWeek,
	proRegularClipboardCheck,
	proRegularCog,
	proRegularEllipsisH,
	proRegularEllipsisV,
	proRegularInfoCircle,
	proRegularSortAlphaDown,
	proRegularSortAlphaDownAlt,
	proRegularSquare,
	proRegularStar,
	proRegularStopwatch,
	proRegularThumbtack,
	proRegularTimesCircle,
	proSolidAlarmSnooze,
	proSolidBars,
	proSolidBellExclamation,
	proSolidBullseyeArrow,
	proSolidCalendarStar,
	proSolidCheckSquare,
	proSolidCommentsQuestionCheck,
	proSolidExclamationSquare,
	proSolidInboxIn,
	proSolidMugTea,
	proSolidPencil,
	proSolidRepeatAlt,
	proSolidSignOut,
	proSolidSync,
	proSolidThumbtack,
	proSolidUserSlash,
	proSolidUsersSlash
);

// REFERENCE

// solid icons
// <font-awesome-icon :icon="['fas', 'icon-name']" />

// brand icons
// <font-awesome-icon :icon="['fab', 'font-awesome']" />

// regular icons
// <font-awesome-icon :icon="['far', 'icon-name']" />

// light icons
// <font-awesome-icon :icon="['fal', 'icon-name']" />

// duotone icons
// <font-awesome-icon :icon="['fad', 'icon-name']" />

export default FontAwesomeIcon;



// WEBPACK FOOTER //
// ./src/lib/FontAwesomeIcon.js